{
  "_format": "hh-sol-artifact-1",
  "contractName": "ServiceConfigurationV3",
  "sourceName": "contracts/ServiceConfigurationV3.sol",
  "abi": [
    {
      "inputs": [],
      "name": "UpgradeRevert",
      "type": "error"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "bytes32",
          "name": "which",
          "type": "bytes32"
        },
        {
          "indexed": false,
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "AddressSet",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "address",
          "name": "previousAdmin",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "address",
          "name": "newAdmin",
          "type": "address"
        }
      ],
      "name": "AdminChanged",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "beacon",
          "type": "address"
        }
      ],
      "name": "BeaconUpgraded",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "version",
          "type": "uint8"
        }
      ],
      "name": "Initialized",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "address",
          "name": "addr",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "bool",
          "name": "value",
          "type": "bool"
        }
      ],
      "name": "LiquidityAssetSet",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "factory",
          "type": "address"
        }
      ],
      "name": "LoanFactorySet",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "factory",
          "type": "address"
        }
      ],
      "name": "LoanLibSet",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "value",
          "type": "uint256"
        }
      ],
      "name": "ParameterSet",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "factory",
          "type": "address"
        }
      ],
      "name": "PoolAdminWalletSet",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "factory",
          "type": "address"
        }
      ],
      "name": "PoolFactoryFlexSet",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "factory",
          "type": "address"
        }
      ],
      "name": "PoolFactorySet",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "factory",
          "type": "address"
        }
      ],
      "name": "PoolLibFlexSet",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "factory",
          "type": "address"
        }
      ],
      "name": "PoolLibSet",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "factory",
          "type": "address"
        }
      ],
      "name": "PoolRegistrySet",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "bool",
          "name": "paused",
          "type": "bool"
        }
      ],
      "name": "ProtocolPaused",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "factory",
          "type": "address"
        }
      ],
      "name": "QueryLibSet",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "previousAdminRole",
          "type": "bytes32"
        },
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "newAdminRole",
          "type": "bytes32"
        }
      ],
      "name": "RoleAdminChanged",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "account",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "sender",
          "type": "address"
        }
      ],
      "name": "RoleGranted",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "account",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "sender",
          "type": "address"
        }
      ],
      "name": "RoleRevoked",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "registry",
          "type": "address"
        }
      ],
      "name": "TermsOfServiceRegistrySet",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "implementation",
          "type": "address"
        }
      ],
      "name": "Upgraded",
      "type": "event"
    },
    {
      "inputs": [],
      "name": "AUTOMATION_ROLE",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "BORROWER_ROLE",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "DEFAULT_ADMIN_ROLE",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "DEPLOYER_ROLE",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "OPERATOR_ROLE",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "PAUSER_ROLE",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "POOL_ADMIN_ROLE",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getLegacyFactories",
      "outputs": [
        {
          "components": [
            {
              "internalType": "enum IFactoryType",
              "name": "factoryType",
              "type": "uint8"
            },
            {
              "internalType": "address",
              "name": "factoryAddress",
              "type": "address"
            }
          ],
          "internalType": "struct LegacyFactoryStruct[]",
          "name": "",
          "type": "tuple[]"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getLoanFactory",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getLoanLib",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getPoolAdminWallet",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getPoolFactory",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getPoolFactoryFlex",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getPoolLib",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getPoolLibFlex",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getPoolRegistry",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getQueryLib",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        }
      ],
      "name": "getRoleAdmin",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getServiceAddressList",
      "outputs": [
        {
          "components": [
            {
              "internalType": "address[]",
              "name": "liquidityAssets",
              "type": "address[]"
            },
            {
              "internalType": "address",
              "name": "tosAcceptanceRegistry",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "loanFactory",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "poolFactoryAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "queryLibAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "poolLibAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "loanLibAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "poolControllerFactoryAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "withdrawControllerFactoryAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "vaultFactoryAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "poolAccessControlFactoryAddress",
              "type": "address"
            }
          ],
          "internalType": "struct SerivceAddressList",
          "name": "addressList",
          "type": "tuple"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getServiceAddressListV3",
      "outputs": [
        {
          "components": [
            {
              "internalType": "address[]",
              "name": "liquidityAssets",
              "type": "address[]"
            },
            {
              "internalType": "address",
              "name": "tosAcceptanceRegistry",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "loanFactory",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "poolFactoryAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "poolFactoryFlexAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "queryLibAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "poolLibAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "poolLibFlexAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "loanLibAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "poolControllerFactoryAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "withdrawControllerFactoryAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "vaultFactoryAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "poolAccessControlFactoryAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "poolControllerFactoryFlexAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "withdrawDepositControllerFactoryFlexAddress",
              "type": "address"
            },
            {
              "internalType": "address",
              "name": "poolRegistryAddress",
              "type": "address"
            }
          ],
          "internalType": "struct SerivceAddressListV3",
          "name": "setLoanFactoryerivceAddressList",
          "type": "tuple"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "grantRole",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "hasRole",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "initialize",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "isAutomation",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "isBorrower",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "isDeployer",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "name": "isLiquidityAsset",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "isOperator",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "isPoolAdmin",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "name": "legacyFactories",
      "outputs": [
        {
          "internalType": "enum IFactoryType",
          "name": "factoryType",
          "type": "uint8"
        },
        {
          "internalType": "address",
          "name": "factoryAddress",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "name": "liquidityAssetKeys",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "loanFactory",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "loanLib",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "paused",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "poolAdminWallet",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "poolFactory",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "poolFactoryFlex",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "poolLib",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "poolLibFlex",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "poolRegistry",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "proxiableUUID",
      "outputs": [
        {
          "internalType": "bytes32",
          "name": "",
          "type": "bytes32"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "queryLib",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "renounceRole",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes32",
          "name": "role",
          "type": "bytes32"
        },
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "revokeRole",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        },
        {
          "internalType": "bool",
          "name": "value",
          "type": "bool"
        }
      ],
      "name": "setLiquidityAsset",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "setLoanFactory",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "setLoanLib",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bool",
          "name": "paused_",
          "type": "bool"
        }
      ],
      "name": "setPaused",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "setPoolAdminWallet",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "setPoolFactory",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "setPoolFactoryFlex",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "setPoolLib",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "setPoolLibFlex",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "setPoolRegistry",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "setQueryLib",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "addr",
          "type": "address"
        }
      ],
      "name": "setToSAcceptanceRegistry",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "bytes4",
          "name": "interfaceId",
          "type": "bytes4"
        }
      ],
      "name": "supportsInterface",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "tosAcceptanceRegistry",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "newImplementation",
          "type": "address"
        }
      ],
      "name": "upgradeTo",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "newImplementation",
          "type": "address"
        },
        {
          "internalType": "bytes",
          "name": "data",
          "type": "bytes"
        }
      ],
      "name": "upgradeToAndCall",
      "outputs": [],
      "stateMutability": "payable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "version",
      "outputs": [
        {
          "internalType": "uint16",
          "name": "",
          "type": "uint16"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    }
  ],
  "bytecode": "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",
  "deployedBytecode": "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",
  "linkReferences": {},
  "deployedLinkReferences": {}
}
